import React from "react";
import App from "./components/App";
import { BrowserRouter } from "react-router-dom";
import "./i18n";
import { createRoot } from "react-dom/client";
import Context from "./context/index";

const container = document.getElementById("root");
const root = createRoot(container);
root.render(
  <BrowserRouter>
    <Context>
      <App />
    </Context>
  </BrowserRouter>
);
